import { useAppState } from '../AppContext';
import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import { getAvailableWidth, enableUploads } from './utils';

import PropTypes from 'prop-types';

import './OnboardingModal.css';

const introMessage = process.env.REACT_APP_ONBOARDING_INTRO
  ? process.env.REACT_APP_ONBOARDING_INTRO
  : 'Welcome to the Document Collection Browser';

const desktopSlides = [
  {
    type: 'text',
    message: introMessage
  },
  {
    type: 'image',
    image: 'slide-1.png',
    title:
      'Search for documents and browse the results using interactive visualizations'
  },
  {
    type: 'image',
    image: 'slide-3.png',
    title: 'Visualize document clusters and similar documents'
  },
  { type: 'image', image: 'slide-4.png', title: 'Browse documents' },
  {
    type: 'image',
    image: 'slide-5.png',
    title: 'And refine your search using the term matrix.'
  },
  {
    type: 'image',
    image: 'matrix-symbols.png',
    title: ''
  },
  {
    type: 'image',
    image: 'slide-6.png',
    title: 'Click a document to open the detail view'
  },
  {
    type: 'image',
    image: 'slide-7.png',
    title: 'Help to grow the collection of documents by uploading your own',
    hidden: !enableUploads
  }
].filter((slide) => !slide.hidden);

const mobileSlides = [
  {
    type: 'text',
    message: introMessage
  },
  {
    type: 'image',
    image: 'browse-mobile.png',
    title: 'Browse documents'
  },
  {
    type: 'image',
    image: 'slide-6.png',
    title: 'Click a document to open the detail view'
  },
  {
    type: 'image',
    image: 'slide-7.png',
    title: 'Help to grow the collection of documents by uploading your own',
    hidden: !enableUploads
  },
  {
    type: 'image',
    image: 'slide-1.png',
    title:
      'The desktop site has more interactive visualizations to help browse documents'
  }
].filter((slide) => !slide.hidden);

const Slide = ({ slide }) => {
  const width = Math.min(1000, getAvailableWidth() * 0.5);

  if (slide.type === 'image') {
    return (
      <>
        <h4 style={{ width: `${width}px` }}>
          <b>{slide.title}</b>
        </h4>
        <img
          src={`/images/onboarding/${slide.image}`}
          width={`${width}px`}
          alt="Screenshot of the user interface."
        />
      </>
    );
  } else if (slide.type === 'text') {
    return <p style={{ width: `${width}px` }}>{slide.message}</p>;
  }
};

const OnboardingModal = ({ slides }) => {
  let [slideNumber, setSlideNumber] = useState(0);

  let [, dispatch] = useAppState();

  const handleClose = () => {
    localStorage.setItem('helpHasBeenViewed', 'true');

    dispatch({
      type: 'SET_ONBOARIDNG_MODAL_OPEN',
      onboardingModalOpen: false
    });
  };

  const nextSlide = () => {
    if (slideNumber < slides.length - 1) {
      setSlideNumber(slideNumber + 1);
    }
  };

  const previousSlide = () => {
    if (slideNumber > 0) {
      setSlideNumber(slideNumber - 1);
    }
  };

  return (
    <>
      <Modal
        show={true}
        onHide={handleClose}
        dialogClassName={'onboardingModal'}
        centered
      >
        <Modal.Header closeButton>
          <h3>
            {slideNumber + 1}/{slides.length}
          </h3>
        </Modal.Header>
        <Modal.Body>
          <Slide slide={slides[slideNumber]} />
        </Modal.Body>

        <Modal.Footer>
          <Button
            style={{
              marginLeft: 0,
              marginRight: 'auto'
            }}
            variant="outline-secondary"
            disabled={slideNumber === 0}
            onClick={previousSlide}
          >
            <BsArrowLeft /> Previous
          </Button>

          <Button
            style={{ margin: 'auto' }}
            variant="outline-danger"
            onClick={handleClose}
          >
            × Close
          </Button>

          <Button
            style={{ marginLeft: 'auto', marginRight: 0 }}
            variant="outline-secondary"
            disabled={slideNumber > slides.length - 2}
            onClick={nextSlide}
          >
            Next <BsArrowRight />
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

OnboardingModal.propTypes = {
  slides: PropTypes.array
};

export { OnboardingModal, desktopSlides, mobileSlides };
